import { usePrivacy } from '../context/PrivacyContext';

const PLACEHOLDERS = {
  money: '€••••',
  number: '••••',
  text: '••••••',
};

export function useMask() {
  const { hidden } = usePrivacy();
  return {
    hidden,
    mask: (displayValue, type = 'text') => (hidden ? (PLACEHOLDERS[type] || PLACEHOLDERS.text) : displayValue),
  };
}

export function Money({ value, formatter, className }) {
  const { hidden } = usePrivacy();
  if (hidden) return <span className={className}>{PLACEHOLDERS.money}</span>;
  return <span className={className}>{formatter ? formatter(value) : `€${Number(value || 0).toFixed(2)}`}</span>;
}

export function Username({ value, className }) {
  const { hidden } = usePrivacy();
  return <span className={className}>{hidden ? PLACEHOLDERS.text : value}</span>;
}
